<template>
    <div class="videos yellow" v-if="!isAuEm">
        <div class="container">
          <h2 data-aos="zoom-in" data-aos-offset="200">{{  common.title }}</h2>

          <carousel :itemsToShow="1.25" :breakpoints="breakpoints">
            <slide class="video__item" v-for="(item, i) in common.videos">
              <div class="white" @click="openModal(i)">
                <img :src="require(`../assets/img/${item.image}`)" alt="">
                <p class="title-text">{{ item.title }}</p>
                <span class="play-video" :data-video-id="item.id"></span>
              </div>
            </slide>

            <template #addons>
              <Navigation />
              <Pagination />
            </template>
          </carousel>

          <p class="info-text" v-if="isCA">{{ common.terms }}</p>

          <div class="modal" id="video-modal">
            <button id="video-modal-close" @click="closeModal"></button>
            <iframe id="video" width="520" height="360" src="" frameborder="0" allowtransparency="true" allowfullscreen></iframe>
            <p></p>
          </div>
        </div>
      </div>
</template>

<script>
import Content from "../data/content";
let lang = process.env.VUE_APP_LOCALITY;
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel'

export default {
    components: {
      Carousel,
      Slide,
      Navigation,
      Pagination,
    },
    setup() {
      return {
        common: Content[lang].commonVideos,
        breakpoints: {
          768: {
            itemsToShow: 2,
            wrapAround: true,
          },
          1024: {
            itemsToShow: 3,
            wrapAround: true
          }
        },
        isAuEm: lang == 'pl_en' ? true : false,
        isCA: lang == 'ca_en' || lang == 'ca_fr' ? true : false
      };
    },
    methods: {
      async openModal(i) {
        let modal = document.getElementById('video-modal');
        let video = document.getElementById('video');
        let overlay = document.getElementById('body-overlay');
        let p = modal.getElementsByTagName('p');
        let titleText = document.getElementsByClassName('title-text');
        let body = document.getElementsByTagName('body');
        let videoID = titleText[i].parentElement.getElementsByClassName('play-video')[0].getAttribute('data-video-id');
        body[0].classList.add('overlay-open');
        modal.style.display = 'block';
        overlay.classList.add('open');
        p[0].textContent = titleText[i].textContent;
        video.setAttribute('src', 'https://www.youtube.com/embed/'+videoID+'?enablejsapi=1&autoplay=1&loop=1&rel=0&wmode=transparent')
      },
      async closeModal() {
        let body = document.getElementsByTagName('body');
        let modal = document.getElementById('video-modal');
        let overlay = document.getElementById('body-overlay');
        body[0].classList.remove('overlay-open');
        modal.style.display = 'none';
        overlay.classList.remove('open');
        video.setAttribute('src', '');
      }
    }
  };
</script>

<style>
/* Videos */

.videos {
  padding-top: 175px;
  padding-bottom: 90px;
}

.videos .info-text {
  text-align: center;
  max-widtH: 500px;
  margin: 25px auto 0;
}

.videos .container {
  max-width: 1021px;
  margin: 0 auto;
  position: relative;
}

.videos .container h2 {
  font-size: 34px;
  line-height: 120%;
  font-family: 'jet-extrabold';
  text-align: center;
  margin: 0 auto 30px;
}

.videos .video__item {
  /* margin-right: 15px; */
}

.videos .video__item .white {
  padding: 24px;
  border-radius: 20px;
  border: 2px solid rgba(38, 38, 50, 0.10);
  min-height: 322px;
  width: calc(100% - 30px);
  transition: background 0.25s ease-in-out;
}

.videos .video__item .white:hover {
  cursor: pointer;
}

.videos .video__item .white:hover p {
  color: #ff8000;
}

.videos .video__item img {
  height: 152px;
  width: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 20px;
  transition: all 0.25s ease-in-out;
}

.videos .video__item .play-video {
  background: url('../assets/img/icons/play-grey.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 30px;
  width: 30px;
  display: block;
  cursor: pointer;
}

.videos .video__item p {
  text-align: left;
  margin: 20px 0;
  font-family: 'jet-bold';
  font-size: 20px;
  line-height: 24px;
  transition: all 0.25s ease-in-out;
}

.video__item.slick-slide {
  margin: 0 10px;
}

.videos .slick-arrow::before, .diaries .slick-arrow::before {
  content: '';
  background: url('../assets/img/icons/chevron.svg');
  display: block;
  height: 30px;
  width: 30px;
  position: relative;
}

.videos .slick-prev, .diaries .slick-prev::before {
  left: -37px;
}

.videos .slick-next, .diaries .slick-next::before {
  right: -48px;
  transform: rotate(180deg);
}

.videos .modal {
  position: fixed;
  top: 50%;
  left: 50%;
  height: 70%;
  width: 50%;
  max-width: 604px;
  max-height: 520px;
  background: white;
  border-radius: 20px;
  text-align: center;
  display: none;
  z-index: 999;
  transform: translate(-50%, -50%);
  border: 2px solid rgba(38, 38, 50, 0.10);
}

.videos .modal iframe {
  border-radius: 20px;
  margin-top: 60px;
}

.videos .modal button {
  background: url('../assets/img/icons/close.svg');
  display: block;
  background-size: contain;
  background-repeat: no-repeat;
  height: 17px;
  width: 17px;
  padding: 0;
  margin: 0;
  position: absolute;
  top: 24px;
  right: 27px;
}

.videos .modal p {
  font-size: 20px;
  font-family: 'jet-bold';
  margin-top: 24px;
}

.carousel__track {
  margin-left: 0;
}

.carousel__prev {
  position: absolute;
  left: -40px;
}

.carousel__next {
  position: absolute;
  right: -40px;
}

.videos .container {
    padding: 0 15px;
}

.carousel__pagination {
  display: none;
}

@media only screen and (max-width: 768px) {
  .videos {
    padding-top: 60px;
  }

  .videos .info-text {
    margin: 85px auto 0;
    widtH: 90%;
  }

  .videos .container h2 {
    font-size: 26px;
  }

  .videos .modal {
    width: calc(100% - 60px);
    height: calc(100% - 16px);
  }

  .videos .modal iframe {
    max-width: 100%;
  }

  .videos .videos__list .slick-dots {
    bottom: -55px;
    z-index: 998;
  }

  .videos .video__item .white {
    min-height: 350px;
    width: calc(100% - 15px);
    margin-right: 15px;
  }

  .carousel__prev, .carousel__next {
    display: none;
  }
}

@media only screen and (max-width: 1024px) {

  .video__item .white {
    width: 100%;
  }
  .carousel__next, .carousel__prev {
    display: none;
  }

  .carousel__pagination-button {
    height: 20px;
    width: 20px;
    margin-right: 15px;
  }

  .carousel__pagination-button::after {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: transparent;
    border: 1px solid #242f30;
  }

  .carousel__pagination-button:hover:after {
    background-color: #242f30;
  }

  .carousel__pagination-button--active::after {
    background: #242f30;
  }
  .carousel__pagination {
    display: flex;
  }
}
</style>